import script from "./PlacesDynamicTopMatter.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlacesDynamicTopMatter.vue?vue&type=script&setup=true&lang=ts"

import "./PlacesDynamicTopMatter.vue?vue&type=style&index=0&id=7f08f655&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f08f655"]])

export default __exports__